import { useQuery } from "@tanstack/react-query";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { mediaList, coverIndex } from "@/lib/media";
import { MediaGallery } from "@/components/MediaGallery";
import PageLoader from "@/components/PageLoader";

export default function PortfolioDetail() {
  const { slug } = useParams();
  const { data: p, isLoading, isError } = useQuery({
    queryKey: ["portfolio", slug],
    queryFn: () => api.get(`/portfolio/${slug}`).then((r) => r.data),
  });

  if (isLoading) return <PageLoader />;
  if (isError || !p) return <div className="pt-32 text-center text-white/50">Project not found.</div>;

  const media = mediaList(p);

  return (
    <div className="pt-24 pb-24 max-w-5xl mx-auto px-5" data-testid="portfolio-detail-page">
      <Link to="/portfolio" className="inline-flex items-center gap-2 text-white/70 hover:text-[#D4AF37] text-sm mb-6" data-testid="back-to-portfolio">
        <ArrowLeft size={16} /> All Work
      </Link>

      <p className="font-mono-label uppercase tracking-[0.25em] text-xs text-[#D4AF37]">{p.category}</p>
      <h1 className="font-display text-4xl md:text-5xl text-white mt-2 mb-8">{p.title}</h1>

      <MediaGallery media={media} title={p.title} startIndex={coverIndex(p)} autoPlayStart={media[coverIndex(p)]?.kind !== "image"} />
    </div>
  );
}
